import React from 'react';
import { Line } from '../../graphs';
import { Loading } from './loading';
import { parseLineData } from './selectors';

export const ComparisonLineGraphs = ({ reportContents, prop }) => {
  const data = [];
  const graphs = {
    [prop.graph]: reportContents.graphs[prop.graph],
  };

  if (!prop.compare) return (<div>No comparison :(</div>);

  prop.compare.forEach((compare) => {
    const key = `${prop.graph}_${compare.to.toLowerCase()}`;
    if (!reportContents.graphs[key]) return;
    // eslint-disable-next-line no-param-reassign
    reportContents.graphs[key].title = compare.label || `${compare.to[0].toUpperCase()}${compare.to.substring(1).toLowerCase()}`;
    graphs[key] = reportContents.graphs[key];
  });

  Object.values(graphs).reverse().forEach((graph) => {
    let layerValuesByKey = parseLineData(graph, undefined, false);

    const { map } = prop;
    const exclude = [
      ...(prop.exclude || []),
      ...[undefined, null, 'undefined', 'null'],
    ];

    if (map) {
      layerValuesByKey = Object.keys(layerValuesByKey).reduce((acc, key) => {
        if (exclude.includes(key)) return acc;
        acc[map[key]] = layerValuesByKey[key];
        return acc;
      }, {});
    }

    Object.keys(layerValuesByKey).forEach((key) => {
      if (layerValuesByKey[key] && layerValuesByKey[key].length) {
        data.push({
          id: graph.title || prop.label || graph.label || key,
          data: layerValuesByKey[key] || [],
        });
      }
    });
  });

  if (!data.length) {
    return <Loading key={`${prop.graph}-${prop.label}`} />;
  }

  return (
    <div
      className="break-after-while-printing"
      style={{
        width: '50%',
        minWidth: 300,
        height: 'auto',
        pageBreakBefore: prop.newPage ? 'always' : 'auto',
      }}
    >
      <div
        {...{ 'data-test': 'line-graph' }}
        key={`${prop.column}-${prop.label}-${'hello'}`}
        style={{
          height: 375,
          width: '100%',
        }}
      >
        <h5>{prop.title || ''}</h5>
        <Line
          hideLegend={prop.hideLegend}
          yLabel={prop.unit || 'Percent'}
          xLabel="Time"
          data={data}
        />
      </div>
    </div>
  );
};
